export const processAndReturnNewForm = (pluginsForm, response, pluginCode) => {
  if (!Object.keys(pluginsForm).includes(pluginCode)) {
    pluginsForm[pluginCode] = response;
  }
  return pluginsForm;
};

export const savePluginFormData = (pluginsFormData, newFormData) => {
  const { pluginCode } = newFormData;
  pluginsFormData[pluginCode] = newFormData;
  console.log('pluginsFormData :>> ', pluginsFormData);
  return pluginsFormData;
};
